import {lazy} from 'react'

export const MikrotikInstructionLazy = lazy(() => import('./MikrotikInstruction'))
